<template>
  <div>
    <Modal
      ref="modal"
      title="Delete template"
      body="Are you sure you want to delete this template? Deleting a template is a permanent action. We cannot restore this template after deletion."
      action="Delete"
      actionColor="red"
      @closeModal="handleCancel"
      @handleAction="deleteEmailTemplate"
    />
  </div>
</template>

<script>
import Modal from '../../shared/Modal.vue';

export default {
  props: ['selectedTemplateId'],
  components: {
    Modal,
  },
  methods: {
    deleteEmailTemplate() {
      const self = this;
      self.$store.commit('general/showLocalLoadingSpinner');
      fetch(`/api/email_templates/${self.selectedTemplateId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0].content,
        },
      })
        .then(response => response.json())
        .then(data => {
          self.$store.commit('general/hideLocalLoadingSpinner');
          if (data.status != 'error') {
            self.$store.commit('general/showAlert', {
              alertType: 'success',
              alertTitle: 'Email template deleted',
              alertDescription:
                'Your email template was successfully deleted.  Use the button below to dismiss this alert.',
            });
            self.$emit('handleSaveSettings');
          } else {
            self.$store.commit('general/showAlert', {
              alertType: 'error',
              alertTitle: 'Email template deletion error',
              alertDescription: data.message,
            });
          }
        });
    },
    handleCancel() {
      this.$emit('handleTemplateDeleteCancel');
    },
  },
};
</script>
